import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkcampaignComponent } from './bulkcampaign/bulkcampaign.component';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [BulkcampaignComponent],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,
    FormsModule
  ]
})
export class BulkcampaignModule { }
